import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '@iconify/react';
import { ImageWithFallback } from '../components/media/ImageWithFallback';

function EducateHer() {
    const [donationAmount, setDonationAmount] = useState('');

    const handleDonate = (e) => {
        e.preventDefault();
        console.log('Donation amount:', donationAmount);
        // Handle donation logic here
    };

    return (
        <div className="educateher-page">
            {/* Hero Section */}
            <section className="program-hero educateher-hero">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="program-badge">
                                <Icon icon="mdi:star" />
                                <span>HSCF-owned Initiative</span>
                            </div>
                            <h1 className="program-hero-title animate-slide-up">EducateHer</h1>
                            <p className="program-hero-subtitle animate-slide-up delay-1">
                                Empowering girls in underserved communities through education.
                            </p>
                            {/*
                            <div className="program-hero-stats animate-slide-up delay-2">
                                <div className="hero-stat">
                                <Icon icon="mdi:account-school" />
                                <div>
                                    <strong>500+</strong>
                                    <span>Scholars</span>
                                </div>
                                </div>
                                <div className="hero-stat">
                                <Icon icon="mdi:school" />
                                <div>
                                    <strong>15+</strong>
                                    <span>Partner Schools</span>
                                </div>
                                </div>
                                <div className="hero-stat">
                                <Icon icon="mdi:trophy" />
                                <div>
                                    <strong>85%</strong>
                                    <span>Success Rate</span>
                                </div>
                                </div>
                            </div>
                            */}
                        </div>
                        <div className="col-lg-6">
                            <div className="program-hero-image animate-fade-in delay-2">
                                <ImageWithFallback
                                    src="https://images.unsplash.com/photo-1553777907-f5dbbbb44d7c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxhZnJpY2FuJTIwc3R1ZGVudHMlMjBlZHVjYXRpb258ZW58MXx8fHwxNzYyNDIwMTMxfDA&ixlib=rb-4.1.0&q=80&w=1080"
                                    alt="EducateHer Program"
                                    className="hero-image"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Overview */}
            <section className="program-overview">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="section-header">
                                <span className="section-label">About the Program</span>
                                <h2 className="section-title">
                                    <i>When a girl stays in school, an entire community moves forward.</i>
                                </h2>
                            </div>
                            <p className="overview-text">
                                Through EducateHer, HSC Foundation is partnering with community leaders, teachers, parents, and local associations to strengthen girls' school attendance, reduce dropout rates, and promote pathways to leadership for young women.
                            </p>
                        </div>
                        {/*
                    <div className="col-lg-4">
                        <div className="quick-facts">
                        <h4>Quick Facts</h4>
                        <div className="fact-item">
                            <Icon icon="mdi:calendar" />
                            <div>
                            <strong>Launched</strong>
                            <span>2025</span>
                            </div>
                        </div>
                        <div className="fact-item">
                            <Icon icon="mdi:account-group" />
                            <div>
                            <strong>Beneficiaries</strong>
                            <span>500+ young women</span>
                            </div>
                        </div>
                        <div className="fact-item">
                            <Icon icon="mdi:map-marker" />
                            <div>
                            <strong>Locations</strong>
                            <span>10 communities</span>
                            </div>
                        </div>
                        <div className="fact-item">
                            <Icon icon="mdi:cash-multiple" />
                            <div>
                            <strong>Investment</strong>
                            <span>$2M+ distributed</span>
                            </div>
                        </div>
                        </div>
                    </div>
                    */}
                    </div>
                </div>
            </section>

            {/* What We Offer */}
            <section className="program-offerings">
                <div className="container">
                    <div className="section-header text-center">
                        <span className="section-label">Program Components</span>
                        <h2 className="section-title">What EducateHer Offers</h2>
                    </div>

                    <div className="row g-4">
                        <div className="col-lg-4 col-md-6">
                            <div className="offering-card">
                                <div className="offering-icon">
                                    <Icon icon="mdi:school" />
                                </div>
                                <h4>Full Scholarships</h4>
                                <p>
                                    Comprehensive financial support covering tuition, books, supplies,
                                    and other educational expenses.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="offering-card">
                                <div className="offering-icon">
                                    <Icon icon="mdi:account-tie" />
                                </div>
                                <h4>Mentorship Program</h4>
                                <p>
                                    One-on-one mentorship with successful women professionals in various fields.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="offering-card">
                                <div className="offering-icon">
                                    <Icon icon="mdi:laptop" />
                                </div>
                                <h4>Technology Access</h4>
                                <p>
                                    Provision of laptops and internet access to ensure digital literacy and connectivity.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="offering-card">
                                <div className="offering-icon">
                                    <Icon icon="mdi:briefcase" />
                                </div>
                                <h4>Career Guidance</h4>
                                <p>
                                    Professional development workshops, internship placement, and career counseling.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="offering-card">
                                <div className="offering-icon">
                                    <Icon icon="mdi:brain" />
                                </div>
                                <h4>Skills Training</h4>
                                <p>
                                    Leadership, communication, and technical skills workshops to enhance employability.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="offering-card">
                                <div className="offering-icon">
                                    <Icon icon="mdi:account-multiple" />
                                </div>
                                <h4>Community Network</h4>
                                <p>
                                    Access to a supportive community of peers, alumni, and professionals.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Success Stories */}
            {/*
            <section className="success-stories">
                <div className="container">
                <div className="section-header text-center">
                    <span className="section-label">Impact Stories</span>
                    <h2 className="section-title">Transforming Lives</h2>
                </div>

                <div className="row g-4">
                    <div className="col-lg-4">
                    <div className="story-card">
                        <div className="story-quote">
                        <Icon icon="mdi:format-quote-open" />
                        </div>
                        <p>
                        "EducateHer didn't just pay for my education – it gave me confidence, 
                        skills, and a network that changed my life. I'm now a software engineer 
                        giving back to my community."
                        </p>
                        <div className="story-author">
                        <strong>Amina K.</strong>
                        <span>Class of 2020</span>
                        </div>
                    </div>
                    </div>
                    <div className="col-lg-4">
                    <div className="story-card">
                        <div className="story-quote">
                        <Icon icon="mdi:format-quote-open" />
                        </div>
                        <p>
                        "The mentorship I received through EducateHer was invaluable. My mentor 
                        guided me through challenges and opened doors I didn't know existed."
                        </p>
                        <div className="story-author">
                        <strong>Grace O.</strong>
                        <span>Class of 2021</span>
                        </div>
                    </div>
                    </div>
                    <div className="col-lg-4">
                    <div className="story-card">
                        <div className="story-quote">
                        <Icon icon="mdi:format-quote-open" />
                        </div>
                        <p>
                        "I'm the first in my family to attend university. EducateHer made my 
                        dream possible and showed me that anything is achievable with support."
                        </p>
                        <div className="story-author">
                        <strong>Fatima M.</strong>
                        <span>Current Scholar</span>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </section>
            */}

            {/* Donate to EducateHer */}
            {/*
            <section className="program-donate">
                <div className="container">
                <div className="donate-card">
                    <div className="row align-items-center">
                    <div className="col-lg-7">
                        <h2>Support EducateHer</h2>
                        <p>
                        Your donation directly impacts a young woman's education and future. 
                        Every contribution, no matter the size, makes a difference.
                        </p>
                        <div className="donation-impact">
                        <div className="impact-item">
                            <Icon icon="mdi:check-circle" />
                            <span>$500 provides school supplies for one scholar for a year</span>
                        </div>
                        <div className="impact-item">
                            <Icon icon="mdi:check-circle" />
                            <span>$2,000 covers one semester of tuition</span>
                        </div>
                        <div className="impact-item">
                            <Icon icon="mdi:check-circle" />
                            <span>$10,000 provides a full scholarship for one year</span>
                        </div>
                        </div>
                    </div>
                    <div className="col-lg-5">
                        <form className="donation-form" onSubmit={handleDonate}>
                        <h4>Make a Donation</h4>
                        <div className="amount-options">
                            <button 
                            type="button" 
                            className={`amount-btn ${donationAmount === '50' ? 'active' : ''}`}
                            onClick={() => setDonationAmount('50')}
                            >
                            $50
                            </button>
                            <button 
                            type="button" 
                            className={`amount-btn ${donationAmount === '100' ? 'active' : ''}`}
                            onClick={() => setDonationAmount('100')}
                            >
                            $100
                            </button>
                            <button 
                            type="button" 
                            className={`amount-btn ${donationAmount === '500' ? 'active' : ''}`}
                            onClick={() => setDonationAmount('500')}
                            >
                            $500
                            </button>
                            <button 
                            type="button" 
                            className={`amount-btn ${donationAmount === '1000' ? 'active' : ''}`}
                            onClick={() => setDonationAmount('1000')}
                            >
                            $1000
                            </button>
                        </div>
                        <div className="custom-amount">
                            <label>Or enter custom amount</label>
                            <input 
                            type="number" 
                            className="form-control" 
                            placeholder="Enter amount"
                            value={donationAmount}
                            onChange={(e) => setDonationAmount(e.target.value)}
                            />
                        </div>
                        <button type="submit" className="btn btn-donate-submit d-flex justify-content-center ">
                            <Icon icon="mdi:hand-heart" className="me-2" />
                            Donate to EducateHer
                        </button>
                        <p className="payment-note">
                            <Icon icon="mdi:shield-check" className="me-1" />
                            Secure payment via Paystack/Flutterwave
                        </p>
                        </form>
                    </div>
                    </div>
                </div>
                </div>
            </section>
            */}
        </div>
    );
}

export default EducateHer;
